"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyZip = void 0;
function applyZip(factory, src, second, resultSelector) {
    function* generator() {
        const firstArr = [...src];
        const secondArr = Array.isArray(second) || typeof second === 'string' ? second : [...second];
        const limit = Math.min(firstArr.length, secondArr.length);
        for (let i = 0; i < limit; i++) {
            if (resultSelector) {
                yield resultSelector(firstArr[i], secondArr[i]);
            }
            else {
                yield [firstArr[i], secondArr[i]];
            }
        }
    }
    return factory.createBasicEnumerable(generator);
}
exports.applyZip = applyZip;
//# sourceMappingURL=applyZip.js.map